import { changeEmailRules } from "./changeEmailRules";

export const resendVerifyNewCodeRules = ({currentEmail, newEmail, code}) => {
    const password = "";
    let changeRules = changeEmailRules({currentEmail, newEmail, password});
    return {
        currentEmail: {... changeRules.currentEmail },
        newEmail: { ... changeRules.newEmail} 
    }
}